import {
    VDataTable,
    VTextField,
    VForm,
    VBtn
} from 'vuetify/lib'
import { mapGetters } from "vuex";
import VModal from '@/vuetify_custom/v-modal_v1'
import {formattingNumber} from '@/libs/util'
import PopTip from '@/views/fin/salaryadministration/components/PopTip.vue'
import { pre_remark_2, illegality_val } from '@/views/fin/salaryadministration/constants.js'
import { makeSlots } from '../utils'
import styles from '../index.module.less'
import remark_mixins from '@/views/fin/salaryadministration/components/remark_mixins.js'
import {getpaymentRatioGetRatioApi, editUpdateRatioApi} from '../service'
import common_mixins from '@/views/fin/salaryadministration/common_mixins.js'
const table_keys = [
    'company_endowment_ratio', 
    'company_medical_ratio', 
    'company_unemployment_ratio', 
    'company_industrial_injury_ratio', 
    'company_maternity_ratio',
    'company_accumulation_fund_ratio',
    'company_supplementary_medical_ratio',
    'person_endowment_ratio',
    'person_medical_ratio',
    'person_unemployment_ratio',
    'person_accumulation_fund_ratio',
]
const disabeld_hash = {
    person_industrial_injury_ratio:true,
    person_maternity_ratio:true,
    // person_supplementary_medical_ratio: true,
}

const EditModal = {
    mixins:[common_mixins, remark_mixins],
    data() {
        this.headers = [
            {
                text: '',
                align: 'center',
                sortable: false,
                value: 'type',
                width: 100
            },
            {
                text: '养老保险',
                align: 'center',
                sortable: false,
                value: 'yanglao',
            },
            {
                text: '医疗保险',
                align: 'center',
                sortable: false,
                value: 'yiliao',
            },
            {
                text: '失业保险',
                align: 'center',
                sortable: false,
                value: 'shiye',
            },
            {
                text: '工伤保险',
                align: 'center',
                sortable: false,
                value: 'gongshang',
            },
            {
                text: '生育保险',
                align: 'center',
                sortable: false,
                value: 'shengyu',
            },
            {
                text: '补充医疗',
                align: 'center',
                sortable: false,
                value: 'buchong',
            },
            {
                text: '公积金',
                align: 'center',
                sortable: false,
                value: 'gongji',
            }
        ]
        return {
            show: false,
            saveLoading: false,
            val: {},
            customer_type: null,
            payment_place: null,
            table_val: [
                {
                    index: 0,
                    type: '单位缴纳',
                    yanglao: 'company_endowment_ratio',
                    yiliao: 'company_medical_ratio',
                    shiye: 'company_unemployment_ratio',
                    gongshang: 'company_industrial_injury_ratio',
                    shengyu: 'company_maternity_ratio',
                    gongji: 'company_accumulation_fund_ratio',
                    buchong: 'company_supplementary_medical_ratio'
                },
                {
                    index: 1,
                    type: '个人缴纳',
                    yanglao: 'person_endowment_ratio',
                    yiliao: 'person_medical_ratio',
                    shiye: 'person_unemployment_ratio',
                    gongshang: 'person_industrial_injury_ratio',
                    shengyu: 'person_maternity_ratio',
                    gongji: 'person_accumulation_fund_ratio',
                    buchong: 'person_supplementary_medical_ratio'
                }
            ]
        }
    },
    methods: {
        edit(data) {
            data = JSON.parse(JSON.stringify(data))
            this.show = true
            this.val = data
        },
        submit() {
            if (this.$refs.form.validate()) {
                // eslint-disable-next-line
                const {updated_at, update_customer_id, update_customer, payment_place, customer_type, customer_sub_type, created_at, ...params} = this.val || {}
                this.$vModal.confirm({
                    title: '提示',
                    content:pre_remark_2,
                    onOk:() => {
                        this.saveLoading = true
                        editUpdateRatioApi(params).then(() => {
                       
                            setTimeout(() => {
                                this.$Message.success({
                                    content: '修改成功!'
                                });
                                this.$emit('success')
                                this.show = false
                                this.saveLoading = false
                                this.successRemark()
                            }, 4000)
                           
                         
                        }).catch(() => {
                            this.saveLoading = false
                        })
                    }
                  })
            }
        }
    },
    mounted() {
      //  this.show = true
    },
    computed:{
        ...mapGetters({
            companies: 'async/companies',
          }),
          is_bj() {
            return this.val && (this.val.payment_place === '北京')
          },
          rules() {

            const obj = {
                salary: [v => !illegality_val.includes(v) || '调整后薪资必填'],
                adjust_ratio: [v => !illegality_val.includes(v) || '调整比例必填'],
                payment_place: [v => !illegality_val.includes(v) || '缴纳地必选'],
                adjust_reason: [v => !illegality_val.includes(v) || '调整原因必填'],
            }
            table_keys.map(key => {
                obj[key] = [v => !illegality_val.includes(v) || '必填']
            })

            return obj
        },
    },
    render() {
        const _this = this
        return <VModal
        dynamicHeight
        heightRate={0.8}
        v-model={_this.show}
        title='修改设置'
        loading={this.saveLoading}
        width={1100}
        ref="modal"
        on={{
          ok: _this.submit
        }}
        >
            <div class={styles['pay-contain']}>
                <p class={styles['header-title']}>
                    员工类型
                </p>
                <p>
                    { this.getEmployeeType(_this.val)}
                </p>
                {/* <p>{_this.val && _this.val.customer_sub_type && '正式员工（实习）' || '正式员工'}</p> */}
                <p class={styles['header-title']}>
                    缴存地
                </p>
                <p>{_this.val && _this.val.payment_place }</p>
                <p class={styles['header-title']}>
                    缴存比例
                </p>
                <div >
                    <VForm 
                    ref="form"
                
                    >
                        <VDataTable
                            item-key="id"
                            hide-default-footer
                            headers={_this.headers}
                            items={_this.table_val}
                            scopedSlots={{
                                'header.buchong': makeSlots(({header}) => {
                                    return <div>{header.text}{this.is_bj && <PopTip showIcon size={14} title="请填写实际缴纳金额"/>}</div>
                                }),
                                item: makeSlots(({item, headers}) => {
                                 
                                    return <tr>
                                        {headers.map(header => {
                                            const key = item[header.value]
                                            const person_cell = item.index === 1 && disabeld_hash[key]
                                            // 成都&&补充医疗&&个人 不能填写 
                                            const is_cd_person = item.index === 1 && !this.is_bj && key === 'person_supplementary_medical_ratio'
                                            const is_bj_company = item.index === 0 && this.is_bj && key === 'company_supplementary_medical_ratio'
                                            if (person_cell || is_cd_person || is_bj_company) {
                                                return <td>-</td>
                                            }
                                            return <td >
                                                { header.value === 'type' && item.type }
                                                { header.value !== 'type' && <div class={styles['td-mt-10']}>
                                                        <VTextField
                                                            v-model={_this.val[key]}
                                                            disabled={item.index === 1 && disabeld_hash[key]}
                                                            required
                                                            rules={_this.rules[key]}
                                                            type="number"
                                                            on={{
                                                                input: (e) => {
                                                                    if (e.includes('.') && (e.length - e.indexOf('.')) >= 4) {
                                                                        this.$nextTick(() => {
                                                                            _this.val[key] = `${parseInt(e)}${e.slice(e.indexOf('.'), e.indexOf('.') + 3)}`
                                                                        })
                                                                    } 
                                                                }
                                                            }}
                                                            scopedSlots={{
                                                            append:makeSlots (() => {
                                                                return this.is_bj && header.value === 'buchong' ? <span/> : <p>%</p> 
                                                            })
                                                            }}/>
                                                    </div>}
                                            </td>
                                        })}
                                    </tr>
                                })
                            }}
                        ></VDataTable>
                </VForm>
                </div>
            </div>
        </VModal>
    }
}


export default {
    mixins:[common_mixins],
    data() {
    this.headers = [
        {
            r_index:1,
            rowspan:2,
            text: '员工类型',
            align: 'center',
            width: 110,
            text_align: styles['align-center'],
            sortable: false,
            value: 'customer_type',
        },
        {
            r_index:1,
            rowspan:2,
            text: '缴存地',
            align: 'center',
            width: 70,
            text_align: styles['align-center'],
            sortable: false,
            value: 'payment_place',
        },
        {
            r_index:3,
            colspan: 7,
            text_parent: '单位缴存比例（%）',
            text: '养老',
            width: 60,
            align: 'center',
            text_align: styles['align-center'],
            sortable: false,
            value: 'company_endowment_ratio',
        },
        {
            r_index:2,
            text: '医疗',
            width: 60,
            align: 'center',
            text_align: styles['align-center'],
            sortable: false,
            value: 'company_medical_ratio',
        },
        {
            r_index:2,
            text: '失业',
            width: 60,
            align: 'center',
            text_align: styles['align-center'],
            sortable: false,
            value: 'company_unemployment_ratio',
        },
        {
            r_index:2,
            text: '工伤',
            align: 'center',
            width: 60,
            text_align: styles['align-center'],
            sortable: false,
            value: 'company_industrial_injury_ratio',
        },
        {
            r_index:2,
            text: '生育',
            align: 'center',
            width: 60,
            text_align: styles['align-center'],
            sortable: false,
            value: 'company_maternity_ratio',
        },
        {
            r_index:2,
            text: '补充医疗',
            align: 'center',
            text_align: styles['align-center'],
            sortable: false,
            width: 90,
            value: 'company_supplementary_medical_ratio',
        },
        {
            r_index:2,
            text: '公积金',
            align: 'center',
            width: 70,
            text_align: styles['align-center'],
            sortable: false,
            value: 'company_accumulation_fund_ratio',
        },
        {
            r_index:3,
            colspan: 5,
            text_parent: '个人缴存比例（%）',
            text: '养老',
            width: 60,
            align: 'center',
            text_align: styles['align-center'],
            sortable: false,
            value: 'person_endowment_ratio',
        },
        {
            r_index:2,
            text: '医疗',
            align: 'center',
            width: 60,
            text_align: styles['align-center'],
            sortable: false,
            value: 'person_medical_ratio',
        },
        {
            r_index:2,
            text: '失业',
            align: 'center',
            width: 60,
            text_align: styles['align-center'],
            sortable: false,
            value: 'person_unemployment_ratio',
        },
        {
            r_index:2,
            text: '补充医疗',
            align: 'center',
            width: 90,
            text_align: styles['align-center'],
            sortable: false,
            value: 'person_supplementary_medical_ratio',
        },
                {
            r_index:2,
            text: '公积金',
            align: 'center',
            width: 70,
            text_align: styles['align-center'],
            sortable: false,
            value: 'person_accumulation_fund_ratio',
        },
        {
            r_index:1,
            rowspan:2,
            text: '操作',
            align: 'center',
            width: 60,
            text_align: styles['align-center'],
            sortable: false,
            value: 'action',
        },
    ]
        return {
            getDataLoading: false,
            desserts: []
        }
    },       
    mounted() {
        this.getData()
    },
    methods: {
        handleText(val, key, item) {
          //   console.log('valval', val)
            if (key === 'customer_type') {
               return this.getEmployeeType(item)
            }
           
            if (
                (item.payment_place === '北京' && key === 'company_supplementary_medical_ratio') || // 北京
                (item.payment_place === '成都' && key === 'person_supplementary_medical_ratio')
                ) {
                return <span>-</span>
               
            }
            if (item.payment_place === '北京' && key === 'person_supplementary_medical_ratio') {
                let val_proxy = val
                if (!isNaN(val)) {
                    val_proxy = formattingNumber(val, 2)
                }
                return <div>
                    <div style="display:flex;width:fit-content;margin:auto"><div>{val_proxy || '-'}</div>  <PopTip showIcon size={14} title="此处为实际缴纳金额"/></div>
                </div> 
            }
            if (!isNaN(val)) {
                return <span>{formattingNumber(val, 2)}</span>
            }
            return val
        },
        getData() {
            this.getDataLoading = true
            getpaymentRatioGetRatioApi().then(res => {
                this.desserts = res
                
                // const item_hash = res.reduce((total, item) => {
                //     total[`${item.customer_type}-${item.payment_place}`] = item
                //     return total
                // }, {})
                // this.desserts = sort_keys.map(key => item_hash[key])
            }).finally(() => {
                this.getDataLoading = false
            });
        }
    },
    render() {
        const _this = this
        return <div>
              <p class={styles['setting-remark']}>设置各缴存地各员工类型的缴存比例，员工按照该比例规则确认自己的社保公积金缴纳比例。</p>
              <p class={styles['header-title']}>
                缴存比例设置
              </p>
              <div >
                <VDataTable
                class={styles.table}
                headers={_this.headers}
                items={_this.desserts}
                loading={_this.getDataLoading}
                item-key="id"
                hide-default-footer
                hide-default-header
                scopedSlots={{
                    'header': makeSlots(({props} = {}) => {
                        const {headers} = props
                        return <thead class="v-data-table-header">
                            <tr>
                              { headers.filter(item => item.r_index !== 2).map((item) => <th 
                                    style={`min-width: ${item.width}px`}
                                    class={
                                        `${styles['th-top']} 
                                        ${styles['th-left']} 
                                        ${item.r_index === 1 && styles['th-bottom']} 
                                        ${item.r_index === 3 && 'text-center'}
                                        ${ item.value === 'action' && styles['th-right']}
                                        ${item.text_align}
                                        `} 
                                    rowspan={item.rowspan}
                                    colspan={item.colspan}>
                                {item.text_parent || item.text}
                                </th>)
                                }
                            </tr>
                            <tr>
                              { headers.filter(item => item.r_index !== 1).map(item => <th style={`min-width: ${item.width}px`} class={`${styles['th-top']} ${styles['th-left']} ${item.text_align}`}>
                                {item.text}
                                </th>)
                                }
                            </tr>
                        </thead>
                    }),
                    'item': makeSlots(({headers, item, index}) => {
                        return <tr>
                            {headers.filter(item => {
                                if ([1, 3].includes(index) && item.value === 'customer_type') {
                                    return false
                                }
                                return true
                            }).map((header, c_index) => {
                                return <td 
                                    rowspan={c_index === 0 && [0, 2].includes(index) && 2}
                                   // style={`font-size:0.75rem`}
                                    class={
                                    `
                                    ${header.value === 'action' && styles['th-right']}
                                    ${styles['th-bottom']} 
                                    ${ styles['th-left']}
                                    ${header.text_align}`} >
              
                                        {header.value === 'action' && <VBtn
                                                                            text
                                                                            color="primary"
                                                                            on={{
                                                                                click:() => {
                                                                                    _this.$refs.modal.edit(item)
                                                                                }
                                                                            }}
                                                                            >修改</VBtn>}
                                        {header.value !== 'action' && _this.handleText(item[header.value], header.value, item) }
                                    </td>
                            })}
                        </tr>
                    })
                }}
            >
            </VDataTable>
                
              </div>
           <EditModal ref="modal" on={{
               success:() => {
                   _this.getData()
               }
           }}/>
        </div>
    }
}